export const PATIENT_PAGE_SIZES = [25, 50, 100, 250, 500] as const;

export type PatientPageSize = (typeof PATIENT_PAGE_SIZES)[number];

export const DEFAULT_PATIENT_PAGE_SIZE: PatientPageSize = 25;

export function isPatientPageSize(value: number): value is PatientPageSize {
    return (PATIENT_PAGE_SIZES as readonly number[]).includes(value);
}

export function parsePatientPageSize(value: unknown): PatientPageSize {
    const parsed = typeof value === "number" ? value : typeof value === "string" ? Number(value) : Number.NaN;
    return isPatientPageSize(parsed) ? parsed : DEFAULT_PATIENT_PAGE_SIZE;
}
